import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../../reducers';
import * as actionsSujet from '../../../actions/sujet';
import BreadCrumbs from '../../../components/BreadCrumbs';
import * as actions from '../../../actions/index';
import { formConfig } from '../CreationOrder/formConfig';
import { getIcon, salutation } from '../../../utils/mappings';
import { Button, EButtonType } from '@repo/apg-ui';
import ErrorContainer from '../../../components/ErrorContainer/ErrorContainer';
import Tooltip from 'rc-tooltip';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  locales: any;
  intl: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  actionsJourney: any;
  validationMessageConfig: any;
  keycloakReady: any;
  actionsSujet: any;
  productionDetails: any;
}

const ProductionOrderConfirmation = (props: Props) => {
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const productionId = params.productionId;

    if (props.keycloakReady) {
      props.actionsSujet.getProductionOrder({ number: productionId });
    }
  }, []);

  const renderUserInfo = (userInfoOrder: any, userInfoDataEC) => {
    const userInfo = userInfoOrder && userInfoOrder.firstname && userInfoOrder.title ? userInfoOrder : userInfoDataEC;

    if (userInfo && userInfo.firstname) {
      return (
        <div>
          <p className='m-0'>{salutation[userInfo.title] || userInfo.title}</p>
          <p className='m-0'>
            {userInfo.firstname} {userInfo.lastname || userInfo.surname}
          </p>
          <p className='m-0'>{userInfo.address || userInfo.street}</p>
          <p className='mb-3'>
            {userInfo.zip} {userInfo.city}
          </p>
          <p className='m-0'>{userInfo.email}</p>
          <p className='m-0'>{userInfo.nr}</p>
        </div>
      );
    }

    return null;
  };

  const {
    userDataEC: { userInfo },
    productionDetails,
    intl,
  } = props;
  const company = productionDetails?.company;
  const sujets = productionDetails?.sujets;
  const comment = productionDetails?.comment;
  const contact = productionDetails?.contact;
  const campaignId = params.campaignId;

  return (
    <>
      <BreadCrumbs
        parentPage={null}
        pageName={intl.formatMessage({
          id: 'ec.navigation.druckService',
          defaultMessage: 'Druck-Service',
        })}
      />
      <div className='container-fluid journey1 overflow-hidden sujet-pages p-0'>
        <div className='pageContainer'>
          <ErrorContainer journeyType='afterSales' />

          <div className='creationOrder'>
            <div className='row justify-content-start'>
              <h3 className='col-8 mt-3 mb-24 title-text-block fw-bold'>
                <FormattedMessage
                  id='as.productionOrderConfirmation.thankYouForPrintJob'
                  defaultMessage='Besten Dank für Ihren Druckauftrag'
                />
              </h3>
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mb-24'>
                <FormattedMessage
                  id='as.productionOrderConfirmation.first-paragraph'
                  defaultMessage='In Kürze wird sich die beauftrage Druckerei mit Ihnen in Verbindung setzen. Die Angaben zu diesem Druckauftrag finden Sie auch jederzeit unter Ihrem Dashboard unter gebuchte Kampagnen.'
                />
              </p>
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mt-2 fw-bold'>
                <FormattedMessage
                  id='as.productionOrderConfirmation.confirmationTitle'
                  defaultMessage='Ihr Druckauftrag zur Kampagne <a></a> / {campaignName} im Überblick'
                  values={{
                    campaignName: props.productionDetails?.campaignname,
                    a: () =>
                      !!productionDetails && (
                        <a
                          rel='noopener noreferrer'
                          href={`${process.env.REACT_APP_PUBLIC_URL}campaign/${
                            productionDetails?.number || productionDetails?.it21campaign
                          }`}
                          target='_blank'
                        >
                          {productionDetails?.number || productionDetails?.it21campaign}
                        </a>
                      ),
                  }}
                />
              </p>
            </div>

            <div className='row justify-content-start'>
              <p className='col-12 my-4 fw-bold'>
                <FormattedMessage id='as.productionOrderConfirmation.first-title' defaultMessage='1. Druckerei' />
              </p>

              {company && (
                <div className='col-12 mb-24'>
                  <p className='m-0'>{company.bezeichnung}</p>
                  <p className='m-0'>{company.strasse}</p>
                  <p className='m-0'>
                    {company.plz} {company.ort}
                  </p>
                  <p className='mb-4'>{company.emaildruckerei}</p>
                  <p className='m-0'>{company.telnrdruckerei}</p>
                </div>
              )}
            </div>

            <div className='row justify-content-start'>
              <p className='col-12 mb-24 fw-bold'>
                <FormattedMessage
                  id='as.productionOrderConfirmation.second-title'
                  defaultMessage='2. Hochgeladenes Sujet'
                />
              </p>

              <div className='d-flex flex-column format-druckservice col-12'>
                {sujets &&
                  sujets.map((sujet, idx) => {
                    if (sujet) {
                      return (
                        <div key={`sujet-block-${idx}`} className='d-flex align-items-start mb-24 customCheckbox'>
                          <span className='d-flex flex-column me-48'>
                            <p className='fw-bold'>
                              <FormattedMessage
                                id='as.productionOrderConfirmation.format'
                                defaultMessage='Format {format}'
                                values={{ format: sujet.format }}
                              />
                            </p>
                            {getIcon(sujet.format)}
                          </span>

                          <span className='d-flex flex-column sujet-column'>
                            <p className='fw-bold'>
                              <FormattedMessage id='as.productionOrderConfirmation.topic' defaultMessage='Sujet' />
                            </p>

                            <div className='fileBlock'>
                              {sujet.mimetype.includes('video') || sujet.mimetype.includes('mp4') ? (
                                <video poster={sujet.mimetype} controls>
                                  <source src={sujet.urloriginal} type={sujet.mimetype} />
                                </video>
                              ) : (
                                <img src={sujet.urlthumbnail} alt='Sujet' />
                              )}
                            </div>
                          </span>

                          <span className='d-flex flex-column text-center'>
                            <p className='fw-bold'>
                              <FormattedMessage
                                id='as.productionOrderConfirmation.numberPosters'
                                defaultMessage='Anzahl Plakate'
                              />
                              <Tooltip
                                placement={'right'}
                                overlay={
                                  <>
                                    <b>
                                      <FormattedMessage
                                        id='ec.components.packages.tooltipSujetTitle'
                                        defaultMessage='Berechnungsbeispiele Anzahl Plakate:'
                                      />
                                    </b>
                                    <br />
                                    <FormattedMessage
                                      id='ec.components.packages.tooltipSujetSubTitle'
                                      defaultMessage='Normal-/Nassplakate und L (Leuchter):'
                                    />
                                    <br />
                                    <FormattedMessage
                                      id='ec.components.packages.tooltipSujetText'
                                      defaultMessage='Anzahl Plakatstellen + 15% = Anzuliefernde Plakate (gerundet auf die nächst höhere Anzahl)'
                                    />
                                    <br />
                                    <FormattedMessage
                                      id='ec.components.packages.tooltipSujetSubTitleTwo'
                                      defaultMessage='LR (Leuchter/Roller - F12LR und F200LR):'
                                    />
                                    <br />
                                    <FormattedMessage
                                      id='ec.components.packages.tooltipSujetTextTwo'
                                      defaultMessage='Anzahl Wochen x Anzahl Plakatstellen + 15% = Anzuliefernde Plakate (gerundet auf die nächst höhere Anzahl).'
                                    />
                                  </>
                                }
                              >
                                <InfoIcon className='ms-3' />
                              </Tooltip>
                            </p>
                            <p className='fw-bold'>{sujet.anzahl}</p>
                          </span>
                        </div>
                      );
                    }

                    return null;
                  })}
              </div>

              {formConfig.upload.file.visible && <div className='col-12 col-sm-6' />}

              {comment && (
                <>
                  <p className='col-8'>
                    <FormattedMessage id='as.productionOrderConfirmation.bemerkungen' defaultMessage='Bemerkungen:' />
                  </p>

                  <p className='col-12 col-sm-6 textarea mb-24'>{comment}</p>
                </>
              )}
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mt-24 mb-4 fw-bold'>
                <FormattedMessage
                  id='as.productionOrderConfirmation.myContactDetails'
                  defaultMessage='3. Meine Kontaktangaben'
                />
              </p>

              <div className='col-9'>
                <div className='d-flex'>
                  <div className='col-6 px-0'>{renderUserInfo(contact, userInfo)}</div>
                </div>
              </div>
            </div>

            <div className='row justify-content-start'>
              <div className='col-9 d-flex twoButtons pe-48'>
                <Button
                  onClick={() => navigate({ pathname: '/campaign/' + campaignId })}
                  buttonType={EButtonType.PillMedium}
                >
                  <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProductionOrderConfirmation)));
